module.exports = __webpack_public_path__ + "img/49_7.fc845185.png";